import { CurrentUser, DisplayNames, EventStream, RealTime } from 'Roblox';
import groupModule from '../groupModule';

function groupWallController(
  $scope,
  $interval,
  groupWallService,
  groupDetailsConstants,
  $log,
  groupResources,
  $uibModal,
  systemFeedbackService,
  thumbnailConstants,
  cursorPaginationService,
  $filter,
  $q,
  captchaV2Constants,
  languageResource,
  groupDetailsService,
  groupsConstants,
  httpService
) {
  'ngInject';

  const ctrl = this;

  $scope.groupWall = {
    posts: [],
    deferredNotifications: [],
    postData: '',
    isPostInProgress: false,
    hasNewPosts: false,
    loadFailure: false,
    postMaxLength: groupDetailsConstants.groupPostMaxLength,

    pager: cursorPaginationService.createPager({
      sortOrder: cursorPaginationService.sortOrder.Desc,
      pageSize: groupDetailsConstants.wallPageSize,
      loadPageSize: groupDetailsConstants.cursorPageLoadSize,

      getCacheKeyParameters() {
        return {
          groupId: ctrl.groupId
        };
      },

      getRequestUrl() {
        return $filter('formatString')(groupDetailsConstants.urls.groupWallPostsV2, {
          id: ctrl.groupId
        });
      },

      getDataListFromResponse(response) {
        return $q(function (resolve, reject) {
          resolve(
            response.data
              .filter(function (post) {
                return post.poster;
              })
              .map($scope.convertResultToPostObject)
          );
        });
      },

      loadSuccess(wallPosts) {
        $scope.groupWall.posts = $scope.groupWall.posts.concat(wallPosts);
        $scope.groupWall.hasNewPosts = false;
      },

      loadError(errors) {
        $log.debug('--loadWallPosts-error---');
        $scope.groupWall.loadFailure = true;
      }
    })
  };

  $scope.notificationHandler = function (data, deferred) {
    if (data.Payload.Type == 'NewPost' && data.Payload.GroupId == ctrl.groupId) {
      if ($scope.groupWall.isPostInProgress && !deferred) {
        $scope.groupWall.deferredNotifications.push(data);
        return;
      }
      if (EventStream) {
        EventStream.SendEventWithTarget(
          'wallPostNotificationReceived',
          'groupWall',
          { groupId: ctrl.groupId, postId: data.Payload.PostId },
          EventStream.TargetTypes.WWW
        );
      }
      if (!$scope.groupWall.hasNewPosts) {
        for (let i = 0; i < $scope.groupWall.posts.length; ++i) {
          if ($scope.groupWall.posts[i].id == data.Payload.PostId) {
            return;
          }
        }
        $scope.$evalAsync($scope => ($scope.groupWall.hasNewPosts = true));
        if (EventStream) {
          EventStream.SendEventWithTarget(
            'seeNewPostsEnabled',
            'groupWall',
            { groupId: ctrl.groupId },
            EventStream.TargetTypes.WWW
          );
        }
      }
    }
  };

  $scope.subscribeToWallNotifications = function () {
    groupWallService.subscribeToWallNotifications(ctrl.groupId);
  };

  $scope.initializeRealTimeUpdates = function () {
    if (RealTime && ctrl.metadata.isGroupWallNotificationsEnabled) {
      $scope.$on('$destroy', () =>
        RealTime.Factory.GetClient().Unsubscribe(
          groupDetailsConstants.groupWallNotificationsNamespace,
          $scope.notificationHandler
        )
      );
      RealTime.Factory.GetClient().Subscribe(
        groupDetailsConstants.groupWallNotificationsNamespace,
        $scope.notificationHandler
      );
      $scope.groupWall.stopSubscribe = $interval(
        $scope.subscribeToWallNotifications,
        ctrl.metadata.groupWallNotificationsSubscribeIntervalInMilliseconds
      );
      $scope.$on(
        '$destroy',
        () => $scope.groupWall.stopSubscribe && $interval.cancel($scope.groupWall.stopSubscribe)
      );
      $scope.subscribeToWallNotifications();
    }
  };

  $scope.convertResultToPostObject = function (result) {
    if (result.poster && result.poster.user) {
      // v2 api also has a role object
      const poster = {
        userId: result.poster.user.userId,
        username: result.poster.user.username,
        displayName: result.poster.user.displayName,
        buildersClubMembershipType: result.poster.user.buildersClubMembershipType,
        role: result.poster.role
      };

      return {
        id: result.id,
        poster,
        body: result.body,
        posted: new Date(result.created)
      };
    }

    const poster = {
      userId: result.poster.userId,
      username: result.poster.username,
      displayName: result.poster.displayName,
      buildersClubMembershipType: result.poster.buildersClubMembershipType,
      role: ctrl.role
    };

    return {
      id: result.id,
      poster,
      body: result.body,
      posted: new Date(result.created)
    };
  };

  $scope.loadAppChatPrivacy = function () {
    groupWallService.loadAppChatPrivacy().then(
      function (result) {
        if (result) {
          $scope.groupWall.appChatPrivacy = result.appChatPrivacy;
        }
      },
      function (data) {
        $log.debug('--loadAppChatPrivacy-error---');
      }
    );
  };

  $scope.canPostToWall = () => {
    return (
      ctrl.permissions &&
      ctrl.permissions.groupPostsPermissions &&
      ctrl.permissions.groupPostsPermissions.postToWall
    );
  };

  $scope.canDeleteWallPost = post => {
    return (
      parseInt(CurrentUser.userId, 10) === post.poster.userId ||
      ($scope.isInGroup() && $scope.canDeleteWallPostOfUserWithRank(post.poster.role.rank))
    );
  };

  $scope.showWallPrivacySettingsText = function () {
    return !$scope.canPostToWall() && $scope.groupWall.appChatPrivacy === 'NoOne';
  };

  $scope.canSendPost = function () {
    return (
      $scope.groupWall.postData &&
      !$scope.groupWall.isPostInProgress &&
      !$scope.groupWall.captchaActivated
    );
  };

  $scope.sendPost = function (captchaPassed, captchaData) {
    if (!captchaPassed && !$scope.canSendPost()) {
      return;
    }

    $scope.groupWall.isPostInProgress = true;

    groupWallService.sendPost(ctrl.groupId, $scope.groupWall.postData, captchaData).then(
      function (result) {
        $scope.groupWall.posts.unshift($scope.convertResultToPostObject(result));
        $scope.groupWall.postData = '';
        $scope.groupWall.isPostInProgress = false;
        $scope.processDeferredNotifications();
      },
      function (data) {
        if (data && data.errors && data.errors[0]) {
          const primaryErrorCode = httpService.getPrimaryApiErrorCode(
            data,
            groupsConstants.errorCodes.sendGroupWallPost
          );
          switch (primaryErrorCode) {
            case groupsConstants.errorCodes.internal.captcha:
              $scope.captchaReturnTokenInSuccessCb = true;
              $scope.groupWall.captchaActivated = true;
              $scope.groupWall.isPostInProgress = false;
              $scope.captchaInputParams = { unifiedCaptchaId: '', dataExchange: '' };
              if (data.errors[0].fieldData) {
                const captchaData = data.errors[0].fieldData;
                let jsonData = '';
                try {
                  jsonData = JSON.parse(captchaData);
                  $scope.captchaInputParams.dataExchange = jsonData.dxBlob;
                  $scope.captchaInputParams.unifiedCaptchaId = jsonData.unifiedCaptchaId;
                } catch (e) {
                  // backward compatible with old version that returns string only.
                  $scope.captchaInputParams.dataExchange = captchaData;
                }
              }
              break;
            default:
              $scope.sendWallPostFailed();
              break;
          }
        }
        $scope.processDeferredNotifications();
      }
    );
  };

  $scope.processDeferredNotifications = function () {
    while ($scope.groupWall.deferredNotifications.length > 0) {
      $scope.notificationHandler($scope.groupWall.deferredNotifications.shift(), true);
    }
  };

  $scope.sendPostCaptchaPassed = function (captchaData) {
    $scope.sendPost(true, captchaData);
  };

  $scope.sendWallPostFailed = function () {
    systemFeedbackService.warning(
      languageResource.get(groupDetailsConstants.translations.sendPostError)
    );
    $scope.groupWall.isPostInProgress = false;
    $log.debug('--sendPost-error---');
  };

  $scope.isInGroup = function () {
    if (ctrl.role) {
      return ctrl.role.id !== null && ctrl.role.rank != 0;
    }

    return false;
  };

  $scope.isInfiniteScrollingDisabled = function () {
    return $scope.groupWall.pager.isBusy() || $scope.groupWall.loadFailure;
  };

  $scope.reloadWallPosts = function () {
    $scope.groupWall.loadFailure = false;
    $scope.groupWall.posts = [];
    $scope.groupWall.pager.loadFirstPage();
  };

  $scope.groupWall.loadMore = function () {
    if ($scope.groupWall.nextPageCursor) {
      $scope.loadWallPosts($scope.groupWall.nextPageCursor);
    }
  };

  $scope.canSeeNewWallPosts = function () {
    return $scope.groupWall.hasNewPosts;
  };

  $scope.seeNewWallPosts = function () {
    $scope.reloadWallPosts();
    if (EventStream) {
      EventStream.SendEventWithTarget(
        'seeNewPostsClicked',
        'groupWall',
        { groupId: ctrl.groupId },
        EventStream.TargetTypes.WWW
      );
    }
  };

  $scope.deleteWallPost = function (post) {
    groupWallService.deleteWallPost(ctrl.groupId, post.id).then(
      function () {
        systemFeedbackService.success(
          languageResource.get(groupDetailsConstants.translations.deleteWallPostSuccess)
        );
        $scope.groupWall.posts.splice($scope.groupWall.posts.indexOf(post), 1);
      },
      function (data) {
        systemFeedbackService.warning(
          languageResource.get(groupDetailsConstants.translations.deleteWallPostError)
        );
        $log.debug('--deleteWallPost-error---');
      }
    );
  };

  $scope.canDeleteWallPostOfUserWithRank = function (userRank) {
    return (
      ctrl.permissions.groupPostsPermissions.deleteFromWall &&
      $scope.isHigherRankThanUserRank(userRank)
    );
  };

  $scope.canExileUserWithRank = function (userRank) {
    return (
      ctrl.permissions.groupMembershipPermissions.removeMembers &&
      $scope.isHigherRankThanUserRank(userRank)
    );
  };

  $scope.isHigherRankThanUserRank = function (userRank) {
    return ctrl.role.rank > userRank;
  };

  $scope.showExileUserModal = function (userId, userRank) {
    const modalParams = {
      animation: false,
      templateUrl: groupResources.modals.exileUser.templateUrl,
      controller: groupResources.modals.exileUser.controller,
      resolve: {
        modalData: {
          groupId: ctrl.groupId,
          userId,
          showDeletePostsCheckbox: $scope.canDeleteWallPostOfUserWithRank(userRank),
          refreshGroupWall() {
            $scope.reloadWallPosts();
          },
          reloadCurrentPage: angular.noop
        }
      }
    };

    $uibModal.open(modalParams);
  };

  $scope.abusePageUrl = function (type, id) {
    return groupDetailsService.abusePageUrl(type, id);
  };

  $scope.profilePageUrl = function (userId) {
    return groupDetailsService.profilePageUrl(userId);
  };


  const init = function () {
    ctrl.isInitialized = true;

    ctrl.isDisplayNamesEnabled = DisplayNames.Enabled();
    ctrl.thumbnailTypes = thumbnailConstants.thumbnailTypes;

    $scope.groupDetailsConstants = groupDetailsConstants;
    $scope.captchaActionTypes = captchaV2Constants.captchaActionTypes;
    $scope.groupWall.pager.loadFirstPage();
    $scope.loadAppChatPrivacy();
    $scope.initializeRealTimeUpdates();
  };

  const onChanges = changesObj => {
    // If we haven't initialized this yet, return
    if (!ctrl.isInitialized) {
      return;
    }

    if ('groupId' in changesObj) {
      $scope.reloadWallPosts();
    }
  };

  ctrl.$onInit = init;
  ctrl.$onChanges = onChanges;
}

groupModule.controller('groupWallController', groupWallController);
export default groupWallController;
